import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import I18n from 'i18n-js';
import { Button } from 'grab-ui';
import _isEmpty from 'lodash/isEmpty';
import { getReceiptRecipients } from 'helper/history-order';
import downloadHelper from 'helper/download-helper';
import { historyBookingSelectionSelector } from 'selectors/new-history-selectors';
import styles from './new-booking-table-page.less';

const HistoryBookingAction = ({ rebookBookings }) => {
  const historyBookingSelection = useSelector(historyBookingSelectionSelector);

  // only return when all selected orders have receipts
  const receiptsToDownload = useMemo(
    () => {
      const allReceipts = [];
      if (!historyBookingSelection || historyBookingSelection.length === 0) {
        return undefined;
      }
      for (let i = 0; i < historyBookingSelection.length; i++) {
        const recipients = getReceiptRecipients(historyBookingSelection[i]);
        if (!recipients || recipients.length === 0) {
          return undefined;
        }
        allReceipts.push(...recipients.map(r => r.orderReceiptLink));
      }
      return allReceipts;
    },
    [historyBookingSelection],
  );
  const downReceipts = useCallback(
    () => {
      if (receiptsToDownload) {
        downloadHelper(receiptsToDownload, 100);
      }
    },
    [receiptsToDownload],
  );

  const rebookSelectedBookings = useCallback(
    () => {
      rebookBookings(historyBookingSelection);
    },
    [rebookBookings, historyBookingSelection],
  );

  return (
    historyBookingSelection &&
    historyBookingSelection.length > 0 && (
      <div className={styles.ongoingBookingAction}>
        <span className={styles.selectedOrderCount}>
          {I18n.t(
            historyBookingSelection.length > 1
              ? 'v2.bookingsPage.selectedBookingsPlural'
              : 'v2.bookingsPage.selectedBookingSingle',
            { num: historyBookingSelection.length },
          )}
        </span>
        <div className={styles.actions}>
          <Button
            className={styles.commonAction}
            onClick={rebookSelectedBookings}
          >
            {I18n.t('v2.orderTable.action.bookAgain')}
          </Button>
          <Button
            className={styles.commonAction}
            onClick={downReceipts}
            disabled={_isEmpty(receiptsToDownload)}
          >
            {I18n.t('v2.orderTable.action.downloadReceipt')}
          </Button>
        </div>
      </div>
    )
  );
};

HistoryBookingAction.propTypes = {
  rebookBookings: PropTypes.func.isRequired,
};

export default HistoryBookingAction;
